import React, { useEffect, useState } from 'react';
import { getPackages } from '../../services/package.service';
import { showError } from '../../utils/notifications';
import styles from './PackageWidget.module.css';
import modalStyles from './PackageModal.module.css';
import { getCurrentAnalystPackage } from '../../services/analyst.service';
import {purchasePackage} from '../../services/package.service';
import { showSuccess } from '../../utils/notifications';
import { loadFeatures } from "../../auth/auth.utils";
// import { useFeatures } from '../../auth/useFeatures';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { setPurchaseSuccess, setPurchaseInProgress } from '../../redux/features/features.slice';
import { selectPurchaseSuccess } from '../../redux/features/features.selector';
import { useRefreshAllFeatures } from '../../redux/features';


// import api from '../../services/api'; // axios instance

// טיפוס מינימלי פנימי (לא חייבת PackageDto)
type PackageType = {
  id: number;
  name: string;
  description?: string | null;
  price?: number | null;
  isDefault?: boolean;
};

interface PackageModalProps {
  package: PackageType;
  onClose: () => void;
}

const PackageModal: React.FC<PackageModalProps> = ({ package: pkg, onClose }) => {
const refreshFeatures = useRefreshAllFeatures();
  const dispatch = useAppDispatch();

  const handleAcceptPackage = async () => {
    try {
      dispatch(setPurchaseInProgress());
      await purchasePackage(pkg.id); // ✅ רכישה
      await loadFeatures(dispatch);          // ✅ מעדכן localStorage
      refreshFeatures();             // ✅ מעדכן React state

      // ✅ שלח סיגנל לכל האפליקציה שיש עדכון
      dispatch(setPurchaseSuccess());

      showSuccess(`קיבלת בהצלחה את החבילה: ${pkg.name}`);
      onClose();
    } catch (error: any) {
      console.error("Error purchasing package:", error);
      showError("שגיאה ברכישת החבילה");
    }
  };
  return (
    <div className={modalStyles.modalOverlay} onClick={onClose}>
      <div className={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={modalStyles.closeButton} onClick={onClose}>✕</button>

        <div className={modalStyles.modalIcon}>🎓</div>
        <h2 className={modalStyles.modalTitle}>{pkg.name}</h2>

        <div className={modalStyles.modalContent}>
          {pkg.description && <p className={modalStyles.description}>{pkg.description}</p>}

          {pkg.price != null && (
<div className={modalStyles.infoBox}>
  <div className={modalStyles.badge}>חינם לחודש ראשון</div>

  <p className={modalStyles.mainText}>
    🎓 <b>סטודנטית יקרה!</b> מגיעה לך חבילת <b>Student</b> ללא עלות לחודש הראשון.
  </p>

  <p className={modalStyles.subText}>
    החבילה כוללת את כל הפיצ'רים הבסיסיים שלנו + תוספות ייחודיות לסטודנטיות:
  </p>

  {/* ✅ נקודות */}
  <div className={modalStyles.bulletsBox}>
    <div className={modalStyles.bulletItem}>
      <span className={modalStyles.dot}></span>
      <span>
        הוספה של עד <b>7 ילדים</b>
      </span>
    </div>

    <div className={modalStyles.bulletItem}>
      <span className={modalStyles.dot}></span>
      <span>
        ניתוח של עד <b>50 סיטואציות</b> באמצעות <b>AI</b>
      </span>
    </div>
  </div>

  <p className={modalStyles.footerNote}>
    * ללא התחייבות. ניתן לשדרג/לבטל בכל שלב.
  </p>
</div>
          )}
        </div>

        <button className={modalStyles.acceptButton} onClick={handleAcceptPackage}>
          קבל את החבילה
        </button>
      </div>
    </div>
  );
};

interface PackageWidgetProps {
  show?: boolean;
}

export const PackageWidget: React.FC<PackageWidgetProps> = ({ show = true }) => {
  const [loading, setLoading] = useState(true);
  const [studentPackage, setStudentPackage] = useState<PackageType | null>(null);
  const [showModal, setShowModal] = useState(false);
  const purchaseSuccess = useAppSelector(selectPurchaseSuccess);

  const fetchStudentPackage = async () => {
    try {
      setLoading(true);

      // ✅ 1) מביאים את החבילה הנוכחית של האנליסט
      const currentPackageRes = await getCurrentAnalystPackage();
      const currentPackage = currentPackageRes as PackageType;

      // ✅ אם החבילה הנוכחית אינה default -> לא מציגים widget בכלל
      if (!currentPackage?.isDefault) {
        setStudentPackage(null);
        return;
      }

      // ✅ 2) מביאים את כל החבילות ומחפשים Student בלבד
      const packages = (await getPackages()) as PackageType[];
      const student = packages.find((p) =>
        p.name?.toLowerCase().includes("student")
      );

      setStudentPackage(student ?? null);
    } catch (error: any) {
      // ✅ אם אין token / אין הרשאה עדיין -> פשוט לא מציגים
      if (error?.response?.status === 401) {
        setStudentPackage(null);
        return;
      }

      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "שגיאה בטעינת החבילות";
      showError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // ✅ אם הרכישה הצליחה, סגור את ה-modal
  useEffect(() => {
    if (purchaseSuccess) {
      setShowModal(false);
    }
  }, [purchaseSuccess]);

useEffect(() => {
  if (!show) return;

  let intervalId: any;

  // ✅ בדיקה: רק כשיש token נשלוף חבילות
  const tryLoad = () => {
    const token = localStorage.getItem("token"); // או getSession()

    if (!token) return; // עדיין לא התחבר -> לא שולף
    if (!show) {
  clearInterval(intervalId);
  return;
}


    clearInterval(intervalId); // ברגע שיש token מפסיקים לבדוק
    fetchStudentPackage();
  };

  // ✅ נסיון ראשון
  tryLoad();

  // ✅ אם אין token - נבדוק כל חצי שניה עד שיופיע
  intervalId = setInterval(tryLoad, 500);

  return () => clearInterval(intervalId);
}, [show, purchaseSuccess]);

  // ✅ אם לא צריך להציג / טוען / אין student -> לא מציג כלום
  if (!show || loading || !studentPackage) return null;

  return (
    <>
      <div className={styles.packageWidget}>
        <div className={styles.packageIcon}>🎓</div>

        <div className={styles.packageContent}>
          <h3 className={styles.packageTitle}>{studentPackage.name}</h3>
          <p className={styles.packageDescription}>
            סטודנטית? זכאית לחבילה מיוחדת
          </p>

          <button className={styles.packageButton} onClick={() => setShowModal(true)}>
            צפה בפרטים
          </button>
        </div>
      </div>

      {showModal && (
        <PackageModal package={studentPackage} onClose={() => setShowModal(false)} />
      )}
    </>
  );
};
